"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoredFilePdfPreview = exports.AttachmentCard = exports.ArtifactPreviewBody = exports.ArtifactCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPdf = require("react-pdf");
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _item = require("@design/ui/item");
var _utils = require("@design/lib/utils");
var _swr = _interopRequireDefault(require("swr"));
var _zod = require("zod");
require("react-pdf/dist/Page/TextLayer.css");
require("react-pdf/dist/Page/AnnotationLayer.css");
var _pdfjsConfig = require("../pdfjs/pdfjsConfig");
var _ArtifactLinkContext = require("./ArtifactLinkContext");
var _useFetchApi5 = require("../hooks/useFetchApi");
var _useResourceQuery2 = require("../hooks/use-resource-query");
var _artifactResource = require("../utils/artifact-resource");
var _artifactIcon = require("../utils/artifactIcon");
var _HtmlArtifactFrame = require("./HtmlArtifactFrame");
var _presignedDownload = require("../utils/presignedDownload");
var _storedFilePdf = require("../utils/storedFilePdf");
var _pdfTextMarks = require("../utils/pdfTextMarks");
var _conversationArtifact = require("../schemas/conversation-artifact");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var artifactReadyBaseSchema = _zod.z.object({
  id: _zod.z.string(),
  name: _zod.z.string(),
  url: _zod.z.string(),
  updatedAt: _zod.z.string()
});
var artifactReadySchema = artifactReadyBaseSchema.and(_conversationArtifact.ArtifactPreviewBodySchema);
var artifactFetchResponseSchema = _zod.z.object({
  artifact: artifactReadySchema.nullish()
});
var previewUrlResponseSchema = _zod.z.object({
  url: _zod.z.string()
});
var pdfPreviewByUrl = new Map();
function fetchPresignedPdfUrl(_x, _x2) {
  return _fetchPresignedPdfUrl.apply(this, arguments);
}
function _fetchPresignedPdfUrl() {
  _fetchPresignedPdfUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fetchCore, artifactId) {
    var raw, parsed;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetchCore("/conversation-artifacts/".concat(encodeURIComponent(artifactId), "/preview-url"));
        case 1:
          raw = _context2.v;
          parsed = previewUrlResponseSchema.safeParse(raw);
          if (parsed.success) {
            _context2.n = 2;
            break;
          }
          throw new Error("preview-url returned no url");
        case 2:
          return _context2.a(2, parsed.data.url);
      }
    }, _callee2);
  }));
  return _fetchPresignedPdfUrl.apply(this, arguments);
}
function resolvePdfUrl(pdfCacheKey, pdfRevision, loadPdfUrl) {
  var cached = pdfPreviewByUrl.get(pdfCacheKey);
  if ((cached === null || cached === void 0 ? void 0 : cached.revision) === pdfRevision) return cached.pdfUrl;
  var pending = loadPdfUrl();
  pending.catch(function () {
    var _pdfPreviewByUrl$get;
    if (((_pdfPreviewByUrl$get = pdfPreviewByUrl.get(pdfCacheKey)) === null || _pdfPreviewByUrl$get === void 0 ? void 0 : _pdfPreviewByUrl$get.pdfUrl) === pending) pdfPreviewByUrl.delete(pdfCacheKey);
  });
  pdfPreviewByUrl.set(pdfCacheKey, {
    revision: pdfRevision,
    pdfUrl: pending
  });
  return pending;
}
var ARTIFACT_PREVIEW_VIEW = "preview";
function fetchArtifactPreview(_x3, _x4) {
  return _fetchArtifactPreview.apply(this, arguments);
}
function _fetchArtifactPreview() {
  _fetchArtifactPreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(fetchCore, artifactId) {
    var _parsed$data$artifact;
    var raw, parsed;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return fetchCore("/conversation-artifacts/".concat(encodeURIComponent(artifactId), "?preview=1"));
        case 1:
          raw = _context3.v;
          parsed = artifactFetchResponseSchema.safeParse(raw);
          return _context3.a(2, parsed.success ? (_parsed$data$artifact = parsed.data.artifact) !== null && _parsed$data$artifact !== void 0 ? _parsed$data$artifact : null : null);
      }
    }, _callee3);
  }));
  return _fetchArtifactPreview.apply(this, arguments);
}
function toCardLoadState(previewArtifact, previewError) {
  if (previewError || previewArtifact === null) return {
    kind: "error"
  };
  if (previewArtifact === undefined) return {
    kind: "loading"
  };
  return {
    kind: "ready",
    artifact: previewArtifact
  };
}
var PdfArtifactPreview = function PdfArtifactPreview(_ref) {
  var artifact = _ref.artifact,
    widthPx = _ref.widthPx,
    loadPdfUrl = _ref.loadPdfUrl;
  var _useFetchApi = (0, _useFetchApi5.useFetchApi)(),
    fetchCore = _useFetchApi.fetchCore;
  var loadArtifactPdfUrl = (0, _react.useCallback)(function () {
    if (loadPdfUrl) return loadPdfUrl(artifact);
    return artifact.type === "pdf" ? fetchPresignedPdfUrl(fetchCore, artifact.id) : (0, _storedFilePdf.fetchConvertedPdfUrl)(fetchCore, artifact.url);
  }, [artifact, fetchCore, loadPdfUrl]);
  if (!artifact.url) return ARTIFACT_PDF_LOADING_VIEW;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PdfPagesPreview, {
    pdfCacheKey: artifact.url,
    pdfRevision: artifact.updatedAt,
    loadPdfUrl: loadArtifactPdfUrl,
    widthPx: widthPx,
    allPages: false,
    loadingView: ARTIFACT_PDF_LOADING_VIEW,
    citedText: null,
    onPreviewShown: null,
    "data-sentry-element": "PdfPagesPreview",
    "data-sentry-component": "PdfArtifactPreview",
    "data-sentry-source-file": "ArtifactCard.tsx"
  });
};
var ARTIFACT_PDF_LOADING_VIEW = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: "h-full animate-pulse bg-background-subtle"
});
var FIRST_PAGE_ONLY = 1;
var CITED_PASSAGE_MARK = '<mark data-cited-passage style="background: rgba(255, 196, 0, 0.35); color: transparent; box-shadow: 0 0 0 1px rgba(214, 150, 0, 0.9); border-radius: 2px;">';
var CITED_PASSAGE_SELECTOR = "mark[data-cited-passage]";
var NO_CITED_PASSAGE = {
  kind: "settled",
  match: null
};
var CITED_PASSAGE_SEARCHING = {
  kind: "searching"
};
function citedPassageSearchFor(citedText) {
  return citedText === null ? NO_CITED_PASSAGE : CITED_PASSAGE_SEARCHING;
}
function pageNumbersThrough(lastPageNumber) {
  return Array.from({
    length: lastPageNumber
  }, function (_, index) {
    return index + 1;
  });
}
var PdfPagesPreview = function PdfPagesPreview(_ref2) {
  var _citedPassage$pageNum;
  var pdfCacheKey = _ref2.pdfCacheKey,
    pdfRevision = _ref2.pdfRevision,
    loadPdfUrl = _ref2.loadPdfUrl,
    widthPx = _ref2.widthPx,
    allPages = _ref2.allPages,
    loadingView = _ref2.loadingView,
    citedText = _ref2.citedText,
    onPreviewShown = _ref2.onPreviewShown;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    pdfUrl = _useState2[0],
    setPdfUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    pdfError = _useState4[0],
    setPdfError = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    healedRevision = _useState6[0],
    setHealedRevision = _useState6[1];
  var _useState7 = (0, _react.useState)(FIRST_PAGE_ONLY),
    _useState8 = _slicedToArray(_useState7, 2),
    loadedPageCount = _useState8[0],
    setLoadedPageCount = _useState8[1];
  var _useState9 = (0, _react.useState)(function () {
      return citedPassageSearchFor(citedText);
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    citedPassageSearch = _useState0[0],
    setCitedPassageSearch = _useState0[1];
  var _useState1 = (0, _react.useState)(function () {
      return new Set();
    }),
    _useState10 = _slicedToArray(_useState1, 2),
    settledPageNumbers = _useState10[0],
    setSettledPageNumbers = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    citedPageTextMarked = _useState12[0],
    setCitedPageTextMarked = _useState12[1];
  var pagesFrameRef = (0, _react.useRef)(null);
  var pdfFile = (0, _react.useMemo)(function () {
    return pdfUrl ? {
      url: pdfUrl
    } : null;
  }, [pdfUrl]);
  var shownPageNumbers = pageNumbersThrough(allPages ? loadedPageCount : FIRST_PAGE_ONLY);
  var citedPassage = citedPassageSearch.kind === "settled" ? citedPassageSearch.match : null;
  var previewShown = pdfError || citedPassageSearch.kind === "settled" && pageNumbersThrough((_citedPassage$pageNum = citedPassage === null || citedPassage === void 0 ? void 0 : citedPassage.pageNumber) !== null && _citedPassage$pageNum !== void 0 ? _citedPassage$pageNum : FIRST_PAGE_ONLY).every(function (pageNumber) {
    return settledPageNumbers.has(pageNumber);
  }) && (citedPassage === null || citedPageTextMarked);
  var markCitedPassage = (0, _react.useMemo)(function () {
    return citedPassage === null ? undefined : function (_ref3) {
      var _citedPassage$marks$g;
      var str = _ref3.str,
        itemIndex = _ref3.itemIndex,
        pageNumber = _ref3.pageNumber;
      return (0, _pdfTextMarks.markedItemHtml)(str, (_citedPassage$marks$g = citedPassage.marks.get(pageNumber)) === null || _citedPassage$marks$g === void 0 ? void 0 : _citedPassage$marks$g.get(itemIndex), CITED_PASSAGE_MARK);
    };
  }, [citedPassage]);
  var handlePdfLoadSuccess = (0, _react.useCallback)(function (pdf) {
    setLoadedPageCount(pdf.numPages);
    if (citedText === null) return;
    (0, _pdfTextMarks.pdfPageTexts)(pdf).then(function (pages) {
      return setCitedPassageSearch({
        kind: "settled",
        match: (0, _pdfTextMarks.citedPassageMatch)(pages, citedText)
      });
    }).catch(function () {
      return setCitedPassageSearch(NO_CITED_PASSAGE);
    });
  }, [citedText]);
  var settlePage = (0, _react.useCallback)(function (pageNumber) {
    setSettledPageNumbers(function (settled) {
      return settled.has(pageNumber) ? settled : new Set(settled).add(pageNumber);
    });
  }, []);
  var markCitedPageText = (0, _react.useCallback)(function () {
    return setCitedPageTextMarked(true);
  }, []);
  var jumpToCitedPassage = (0, _react.useCallback)(function () {
    var _pagesFrameRef$curren;
    (_pagesFrameRef$curren = pagesFrameRef.current) === null || _pagesFrameRef$curren === void 0 || (_pagesFrameRef$curren = _pagesFrameRef$curren.querySelector(CITED_PASSAGE_SELECTOR)) === null || _pagesFrameRef$curren === void 0 || _pagesFrameRef$curren.scrollIntoView({
      block: "center"
    });
  }, []);
  (0, _react.useLayoutEffect)(function () {
    if (!previewShown) return;
    if (citedPassage !== null) jumpToCitedPassage();
    onPreviewShown === null || onPreviewShown === void 0 || onPreviewShown(citedPassage === null ? null : jumpToCitedPassage);
  }, [previewShown, citedPassage, jumpToCitedPassage, onPreviewShown]);
  (0, _react.useEffect)(function () {
    var cancelled = false;
    setPdfUrl(null);
    setPdfError(false);
    setLoadedPageCount(FIRST_PAGE_ONLY);
    setCitedPassageSearch(citedPassageSearchFor(citedText));
    setSettledPageNumbers(new Set());
    setCitedPageTextMarked(false);
    resolvePdfUrl(pdfCacheKey, pdfRevision, loadPdfUrl).then(function (url) {
      if (!cancelled) setPdfUrl(url);
    }).catch(function () {
      if (!cancelled) setPdfError(true);
    });
    return function () {
      cancelled = true;
    };
  }, [pdfCacheKey, pdfRevision, loadPdfUrl, healedRevision, citedText]);
  var handlePdfLoadError = (0, _react.useCallback)(function () {
    if (healedRevision === pdfRevision) {
      setPdfError(true);
      return;
    }
    pdfPreviewByUrl.delete(pdfCacheKey);
    setHealedRevision(pdfRevision);
  }, [healedRevision, pdfRevision, pdfCacheKey]);
  if (pdfError) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex h-full items-center justify-center bg-background-subtle text-xs text-foreground-muted",
      children: "Could not load preview."
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "relative h-full",
    "data-sentry-component": "PdfPagesPreview",
    "data-sentry-source-file": "ArtifactCard.tsx",
    children: [pdfFile === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: pagesFrameRef,
      className: (0, _utils.cn)("h-full bg-background-card", allPages ? "overflow-y-auto" : "overflow-hidden"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPdf.Document, {
        file: pdfFile,
        loading: null,
        error: null,
        onLoadSuccess: handlePdfLoadSuccess,
        onLoadError: handlePdfLoadError,
        onSourceError: handlePdfLoadError,
        externalLinkTarget: "_blank",
        options: _pdfjsConfig.PDF_JS_OPTIONS,
        children: shownPageNumbers.map(function (pageNumber) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPdf.Page, {
            pageNumber: pageNumber,
            width: widthPx,
            loading: null,
            renderAnnotationLayer: false,
            renderTextLayer: citedText !== null,
            customTextRenderer: markCitedPassage,
            onLoadError: function onLoadError() {
              return settlePage(pageNumber);
            },
            onRenderSuccess: function onRenderSuccess() {
              return settlePage(pageNumber);
            },
            onRenderError: function onRenderError() {
              return settlePage(pageNumber);
            },
            onRenderTextLayerSuccess: (citedPassage === null || citedPassage === void 0 ? void 0 : citedPassage.pageNumber) === pageNumber ? markCitedPageText : undefined,
            onRenderTextLayerError: (citedPassage === null || citedPassage === void 0 ? void 0 : citedPassage.pageNumber) === pageNumber ? markCitedPageText : undefined
          }, pageNumber);
        })
      })
    }), previewShown || loadingView === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "absolute inset-0",
      children: loadingView
    })]
  });
};
var TableArtifactPreview = function TableArtifactPreview(_ref4) {
  var columns = _ref4.columns,
    rows = _ref4.rows;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", {
    className: "w-full border-collapse text-xs text-foreground-primary",
    "data-sentry-component": "TableArtifactPreview",
    "data-sentry-source-file": "ArtifactCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: columns.map(function (column, columnIndex) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            className: "sticky top-0 border-b border-border-subtle bg-background-subtle px-2 py-1 text-left font-medium",
            children: column
          }, columnIndex);
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
      children: rows.map(function (row, rowIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: row.cells.map(function (cell, cellIndex) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
              className: "border-b border-border-subtle px-2 py-1 align-top",
              children: (0, _conversationArtifact.cellDisplayText)(cell)
            }, cellIndex);
          })
        }, rowIndex);
      })
    })]
  });
};
var FileTypeCard = function FileTypeCard(_ref5) {
  var artifactType = _ref5.artifactType,
    title = _ref5.title,
    subtitle = _ref5.subtitle;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
    size: "sm",
    "data-sentry-element": "Item",
    "data-sentry-component": "FileTypeCard",
    "data-sentry-source-file": "ArtifactCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
      variant: "icon",
      "data-sentry-element": "ItemMedia",
      "data-sentry-source-file": "ArtifactCard.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_artifactIcon.ArtifactTypeIcon, {
        artifactType: artifactType,
        "data-sentry-element": "ArtifactTypeIcon",
        "data-sentry-source-file": "ArtifactCard.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.ItemContent, {
      className: "min-w-0",
      "data-sentry-element": "ItemContent",
      "data-sentry-source-file": "ArtifactCard.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
        "data-sentry-element": "ItemTitle",
        "data-sentry-source-file": "ArtifactCard.tsx",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemDescription, {
        className: "truncate",
        "data-sentry-element": "ItemDescription",
        "data-sentry-source-file": "ArtifactCard.tsx",
        children: subtitle
      })]
    })]
  });
};
var ArtifactPreviewBody = exports.ArtifactPreviewBody = function ArtifactPreviewBody(_ref6) {
  var artifact = _ref6.artifact,
    renderMarkdown = _ref6.renderMarkdown,
    widthPx = _ref6.widthPx,
    loadPdfUrl = _ref6.loadPdfUrl;
  switch (artifact.type) {
    case "docx":
    case "pptx":
    case "pdf":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(PdfArtifactPreview, {
        artifact: artifact,
        widthPx: widthPx,
        loadPdfUrl: loadPdfUrl
      });
    case "xlsx":
      return artifact.columns && artifact.rows ? /*#__PURE__*/(0, _jsxRuntime.jsx)(TableArtifactPreview, {
        columns: artifact.columns,
        rows: artifact.rows
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(FileTypeCard, {
        artifactType: "xlsx",
        title: "Spreadsheet",
        subtitle: "click to open \xB7 download as .xlsx"
      });
    case "md":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "prose prose-sm max-w-none p-3",
        children: renderMarkdown(artifact.content)
      });
    case "txt":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
        className: "whitespace-pre-wrap break-words p-3 font-mono text-xs text-foreground-primary",
        children: artifact.content
      });
    case "zip":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(FileTypeCard, {
        artifactType: "zip",
        title: "Zip archive",
        subtitle: "download to open its files"
      });
    case "html":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_HtmlArtifactFrame.HtmlArtifactFrame, {
        title: artifact.name,
        html: artifact.content,
        className: "h-full w-full border-0"
      });
    default:
      return artifact;
  }
};
var ArtifactCardFrame = function ArtifactCardFrame(_ref7) {
  var load = _ref7.load,
    widthPx = _ref7.widthPx,
    bodyHeightPx = _ref7.bodyHeightPx,
    title = _ref7.title,
    renderBody = _ref7.renderBody,
    onOpen = _ref7.onOpen,
    onEdit = _ref7.onEdit,
    onDownload = _ref7.onDownload;
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDownloading = _useState14[0],
    setIsDownloading = _useState14[1];
  var isLoading = load.kind === "loading";
  var handleDownload = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            e.stopPropagation();
            if (!(!onDownload || isDownloading)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsDownloading(true);
            _context.p = 2;
            _context.n = 3;
            return onDownload();
          case 3:
            _context.p = 3;
            setIsDownloading(false);
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[2,, 3, 4]]);
    }));
    return function handleDownload(_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
  var handleEdit = function handleEdit(e) {
    e.stopPropagation();
    onEdit === null || onEdit === void 0 || onEdit();
  };
  var headerNode = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardHeader, {
    className: "border-b",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardTitle, {
      className: (0, _utils.cn)("truncate", title === null && "text-muted-foreground"),
      children: title !== null && title !== void 0 ? title : isLoading ? "Loading preview…" : "Preview unavailable"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardAction, {
      className: "flex items-center gap-1",
      children: [onEdit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        asChild: true,
        variant: "ghost",
        size: "icon-xs",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          role: "button",
          tabIndex: 0,
          "aria-label": "Edit artifact",
          title: "Edit artifact",
          onClick: handleEdit,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleEdit(e);
            }
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {})
        })
      }), onDownload && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        asChild: true,
        variant: "ghost",
        size: "icon-xs",
        className: (0, _utils.cn)(isDownloading && "opacity-50"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          role: "button",
          tabIndex: 0,
          "aria-label": "Download artifact",
          title: isDownloading ? "Downloading…" : "Download",
          onClick: handleDownload,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleDownload(e);
            }
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {})
        })
      })]
    })]
  });
  var body = load.kind === "ready" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "artifact-card-body",
    style: {
      height: bodyHeightPx
    },
    className: "overflow-y-auto",
    children: renderBody(load.artifact)
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "artifact-card-body",
    style: {
      height: bodyHeightPx
    },
    className: (0, _utils.cn)("bg-muted", isLoading && "animate-pulse")
  });
  if (onOpen) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
      size: "sm",
      role: "button",
      tabIndex: 0,
      onClick: onOpen,
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen();
        }
      },
      title: "Open preview",
      className: "my-2 cursor-pointer text-left",
      style: {
        width: widthPx
      },
      children: [headerNode, body]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: "my-2 text-left",
    style: {
      width: widthPx
    },
    "data-sentry-element": "Card",
    "data-sentry-component": "ArtifactCardFrame",
    "data-sentry-source-file": "ArtifactCard.tsx",
    children: [headerNode, body]
  });
};
var ArtifactCard = exports.ArtifactCard = function ArtifactCard(props) {
  var artifactId = props.artifactId,
    widthPx = props.widthPx,
    bodyHeightPx = props.bodyHeightPx,
    renderHeader = props.renderHeader,
    renderBody = props.renderBody,
    cardClickable = props.cardClickable;
  var _useFetchApi2 = (0, _useFetchApi5.useFetchApi)(),
    fetchCore = _useFetchApi2.fetchCore;
  var openArtifact = (0, _ArtifactLinkContext.useOpenArtifact)();
  var _useResourceQuery = (0, _useResourceQuery2.useResourceQuery)((0, _artifactResource.artifactResource)(artifactId), ARTIFACT_PREVIEW_VIEW, function (artifact) {
      return fetchArtifactPreview(fetchCore, artifact.id);
    }),
    previewArtifact = _useResourceQuery.data,
    previewError = _useResourceQuery.error;
  var load = toCardLoadState(previewArtifact, previewError);
  var isReady = load.kind === "ready";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ArtifactCardFrame, {
    load: load,
    widthPx: widthPx,
    bodyHeightPx: bodyHeightPx,
    title: isReady ? renderHeader(load.artifact) : null,
    renderBody: renderBody,
    onOpen: isReady && cardClickable ? function () {
      return openArtifact(artifactId);
    } : null,
    onEdit: isReady && props.showEditButton ? function () {
      return props.onEditClick(artifactId);
    } : null,
    onDownload: isReady && props.showDownloadButton ? function () {
      return props.onDownload(artifactId);
    } : null,
    "data-sentry-element": "ArtifactCardFrame",
    "data-sentry-component": "ArtifactCard",
    "data-sentry-source-file": "ArtifactCard.tsx"
  });
};
var ATTACHMENT_PREVIEW_VIEW = "attachment-preview";
var STORED_FILE_REVISION = "stored";
var StoredFilePdfPreview = exports.StoredFilePdfPreview = function StoredFilePdfPreview(_ref9) {
  var storageUrl = _ref9.storageUrl,
    fileName = _ref9.fileName,
    widthPx = _ref9.widthPx,
    citedText = _ref9.citedText,
    onPreviewShown = _ref9.onPreviewShown;
  var _useFetchApi3 = (0, _useFetchApi5.useFetchApi)(),
    fetchWeb = _useFetchApi3.fetchWeb,
    fetchCore = _useFetchApi3.fetchCore;
  var loadStoredFilePdfUrl = (0, _react.useCallback)(function () {
    return (0, _storedFilePdf.fetchStoredFilePdfUrl)(function (path) {
      return fetchWeb(path);
    }, fetchCore, storageUrl, fileName);
  }, [fetchWeb, fetchCore, storageUrl, fileName]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PdfPagesPreview, {
    pdfCacheKey: storageUrl,
    pdfRevision: STORED_FILE_REVISION,
    loadPdfUrl: loadStoredFilePdfUrl,
    widthPx: widthPx,
    allPages: true,
    loadingView: null,
    citedText: citedText,
    onPreviewShown: onPreviewShown,
    "data-sentry-element": "PdfPagesPreview",
    "data-sentry-component": "StoredFilePdfPreview",
    "data-sentry-source-file": "ArtifactCard.tsx"
  });
};
function fetchAttachmentPreview(_x6, _x7) {
  return _fetchAttachmentPreview.apply(this, arguments);
}
function _fetchAttachmentPreview() {
  _fetchAttachmentPreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(fetchWeb, attachment) {
    var _AttachmentPreviewRes, preview, _t;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _t = _conversationArtifact.AttachmentPreviewResponseSchema;
          _context4.n = 1;
          return fetchWeb((0, _conversationArtifact.attachmentPreviewPath)(attachment.attachment_id));
        case 1:
          _AttachmentPreviewRes = _t.parse.call(_t, _context4.v);
          preview = _AttachmentPreviewRes.preview;
          if (!(preview === null)) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, null);
        case 2:
          return _context4.a(2, _objectSpread({
            id: attachment.attachment_id,
            name: attachment.file_name,
            url: attachment.storage_url,
            updatedAt: STORED_FILE_REVISION
          }, preview));
      }
    }, _callee4);
  }));
  return _fetchAttachmentPreview.apply(this, arguments);
}
var AttachmentCard = exports.AttachmentCard = function AttachmentCard(_ref0) {
  var attachment = _ref0.attachment,
    widthPx = _ref0.widthPx,
    bodyHeightPx = _ref0.bodyHeightPx,
    renderMarkdown = _ref0.renderMarkdown;
  var _useFetchApi4 = (0, _useFetchApi5.useFetchApi)(),
    fetchWeb = _useFetchApi4.fetchWeb,
    fetchCore = _useFetchApi4.fetchCore;
  var _useSWR = (0, _swr.default)([ATTACHMENT_PREVIEW_VIEW, attachment.attachment_id], function () {
      return fetchAttachmentPreview(fetchWeb, attachment);
    }, {
      revalidateOnFocus: false,
      shouldRetryOnError: false
    }),
    previewArtifact = _useSWR.data,
    previewError = _useSWR.error;
  var loadAttachmentPdfUrl = (0, _react.useCallback)(function (artifact) {
    return artifact.type === "pdf" ? (0, _presignedDownload.fetchPresignedDownloadUrl)(function (path) {
      return fetchWeb(path);
    }, attachment.storage_url, attachment.file_name) : (0, _storedFilePdf.fetchConvertedPdfUrl)(fetchCore, attachment.storage_url);
  }, [fetchWeb, fetchCore, attachment.storage_url, attachment.file_name]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ArtifactCardFrame, {
    load: toCardLoadState(previewArtifact, previewError),
    widthPx: widthPx,
    bodyHeightPx: bodyHeightPx,
    title: attachment.file_name,
    renderBody: function renderBody(artifact) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ArtifactPreviewBody, {
        artifact: artifact,
        renderMarkdown: renderMarkdown,
        widthPx: widthPx,
        loadPdfUrl: loadAttachmentPdfUrl
      });
    },
    onOpen: null,
    onEdit: null,
    onDownload: function onDownload() {
      return (0, _presignedDownload.downloadStoredObject)(function (path) {
        return fetchWeb(path);
      }, attachment.storage_url, attachment.file_name);
    },
    "data-sentry-element": "ArtifactCardFrame",
    "data-sentry-component": "AttachmentCard",
    "data-sentry-source-file": "ArtifactCard.tsx"
  });
};